import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Contact from 'core/models/contact';
import { SSubCards } from './styles';
import ContactSubCard from 'components/Contact/ContactSubCard';
import CardWithTitle from 'components/CardWithTitle';
import { useApplicationById } from 'core/api/applications';

type LinkedContactsProps = {
    applicationId: string;
};

const LinkedContacts: FC<LinkedContactsProps> = ({ applicationId }) => {
    const { t } = useTranslation();
    const application = useApplicationById(applicationId).data;

    if (!application?.contacts || !application.contacts.length) {
        return null;
    }

    return (
        <CardWithTitle label={t('application.associated-contacts')}>
            <SSubCards>
                {application?.contacts.map((contact: Contact) => (
                    <ContactSubCard key={contact.id} contact={contact} />
                ))}
            </SSubCards>
        </CardWithTitle>
    );
};

export default LinkedContacts;
